import React, { FC, useEffect, useState } from "react";
import { useAuth } from "hooks‬/Auth";

const getGreeting = (hour: number): string => {
  if (hour < 5)  return "Late night";
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};

const DAY_NAMES = [
  "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
];

const DashboardGreeting: FC = () => {
  const { userDetails } = useAuth();
  const [greeting, setGreeting] = useState("");
  const [day, setDay] = useState("");

  useEffect(() => {
    const now = new Date();
    setGreeting(getGreeting(now.getHours()));
    setDay(DAY_NAMES[now.getDay()]);
  }, []);

  // Defensive: try several common shapes for the name
  const firstName =
    userDetails?.firstName ||
    userDetails?.first_name ||
    userDetails?.name?.split(" ")?.[0] ||
    "back";

  return (
    <div className="ni-dash-greeting">
      <svg
        className="ni-dash-greeting-blob"
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="niDashGreetBlob" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%"   stopColor="var(--ni-dash-brand-soft)" />
            <stop offset="100%" stopColor="var(--ni-dash-brand-3)" />
          </linearGradient>
        </defs>
        <path
          fill="url(#niDashGreetBlob)"
          opacity="0.45"
          d="M44.7,-58.6C56.3,-49.2,63.2,-34.1,67.4,-18.3C71.6,-2.5,73,14,67.1,27.4C61.2,40.7,48.1,50.9,33.5,57.6C19,64.3,3.1,67.5,-12.9,65.8C-28.9,64.1,-45,57.4,-55.4,45.8C-65.8,34.2,-70.5,17.1,-70.6,0C-70.6,-17.2,-66,-34.3,-55.6,-44.4C-45.2,-54.4,-29.1,-57.4,-13.6,-58.2C2,-59,33,-68,44.7,-58.6Z"
          transform="translate(100 100)"
        />
      </svg>

      <div className="ni-dash-greeting-content">
        <div className="ni-dash-greeting-row">
          <span className="ni-dash-live-dot" aria-hidden="true" />
          <span className="ni-dash-greeting-label">
            {day} • {greeting}
          </span>
        </div>
        <h1 className="ni-dash-greeting-title">
          Welcome back, <span className="ni-dash-greeting-accent">{firstName}</span>
        </h1>
        <p className="ni-dash-greeting-sub">
          Here&rsquo;s an overview of your subscription, apps, and what&rsquo;s available to explore.
        </p>
      </div>
    </div>
  );
};

export default DashboardGreeting;
